module.exports = __webpack_public_path__ + "static/media/Babar.720c6412.jpg";